import React, { useContext, useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import config from "../../config";
import { GlobalContext } from "../../global/GlobalProvider";
import BetDetailsPopup from "./BetDetailsPopup";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useTranslation } from "react-i18next";

export default function LiveCasinoResult() {
  const { t, i18n } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [selectedTypes, setSelectedTypes] = useState("");
  const [selectedProvider, setSelectedProvider] = useState("");
  const initialized = useRef(false);
  const token = sessionStorage.getItem("token");
  const [searchText, setSearchText] = useState("");

  const [betsData, setBetsData] = useState([]);
  const { setAlertMsg, openSuccessPopup, openErrorPopup, setLoading} = useContext(GlobalContext);

  const currentDate = new Date();
  const minToDate = fromDate
    ? new Date(fromDate.getTime() + 24 * 60 * 60 * 1000)
    : null;
  const formatDate = (date) => {
        if (!date) return "";
        return date.toLocaleDateString("en-CA");
    };

    const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
        <input
          style={{ cursor: "pointer" }}
          onClick={onClick}
          value={value}
          ref={ref}
          readOnly
          placeholder={config.getDateFormated}
        />
      ));

      useEffect(() => {
        if (!initialized.current) {
          initialized.current = true;
          callAPIList()
        }
      });

      const handleTypeChange = (event) => {
        setSelectedProvider('');
        setSelectedTypes(event.target.value);
      };

      const handleProviderChnage = (event) => {
        setSelectedProvider(event.target.value);
      }

      const formatDatefromAPI = (isoDate) => {
        const date = new Date(isoDate);

        // Get date components
        const day = String(date.getUTCDate()).padStart(2, "0");
        const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
        const year = date.getUTCFullYear();

        // Get time components in UTC+05:30 (Indian Standard Time)
        const options = { timeZone: "Asia/Kolkata", hour12: false };
        const timeString = date.toLocaleTimeString("en-GB", options); // 24-hour format HH:mm:ss

        // Get the UTC offset (+05:30)
        const offset = date.getTimezoneOffset(); // Returns offset in minutes
        const offsetHours = String(Math.abs(offset) / 60).padStart(2, "0");
        const offsetMinutes = String(Math.abs(offset) % 60).padStart(2, "0");
        const offsetSign = offset > 0 ? "-" : "+";

        return `${day}/${month}/${year} ${timeString} (UTC${offsetSign}${offsetHours}:${offsetMinutes})`;
    };

    const filteredData = betsData.filter((item) =>
      searchText
        ? [
            item.event,
            item.returns,
            item.Stake,
            item.date,
            item.roundId,
            item.transactionId,
            formatDatefromAPI(item.date),
          ].some((field) => String(field).toLowerCase().includes(searchText.toLowerCase()))
        : true
    );
    // Pagination state
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    // Calculate total pages dynamically
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    // Reset to first page when itemsPerPage changes
    useEffect(() => {
      setCurrentPage(1);
    }, [itemsPerPage]);

    // Get current page data
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    // Page navigation functions
    const firstPage = () => setCurrentPage(1);
    const lastPage = () => setCurrentPage(totalPages);
    const nextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    const prevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
    const goToPage = (page) => setCurrentPage(page);

    const handleClose = () => {
      setDialogOpen(false);
    }

    const callAPIList = () => {
      setLoading(true);
      firstPage();
      setBetsData([]);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      let raw = JSON.stringify({
        provider: selectedProvider,
        date:formatDate(fromDate),
        sporttype:'casino',
        bettype:selectedTypes
      });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

      fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/Account/getcasinosportbookbets`, requestOptions)
      .then(async (response) => {
          let paresData = await response.json();
          if (response.ok) {
            setBetsData(paresData.mybets);
          }else{
            openErrorPopup();
            setAlertMsg(paresData.message);
          }
        setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    }

const generateCSV = () => {
      // Convert data to CSV format
      const headers = "Game Name,Type,Amount,Total,Date,Round Id,Transaction Id\n";
      const rows = currentItems.map(item => `${item.event},${item.returns > 0 ? "CREDIT":'DEBIT'},${item.Stake},${item.returns},${formatDatefromAPI(item.date)},${item.roundId},${item.transactionId}`).join("\n");

      // Create Blob and download
      let name = `LiveCasinoResult_${Date.now()}.csv`
      const csvContent = "data:text/csv;charset=utf-8," + headers + rows;
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
    };

    const generatePDF = () => {
      const doc = new jsPDF();

      const headers = [["Game Name","Type","Amount","Total","Date","Round Id","Transaction Id"]];

      // Map Data to Table Format
      const tableData = currentItems.map((item) => [item.event, item.returns > 0 ? "CREDIT":'DEBIT', item.Stake,item.returns,formatDatefromAPI(item.date),item.roundId,item.transactionId]);

      // Use autoTable with Proper Import
      autoTable(doc, {
        head: headers,
        body: tableData,
        startY: 20, // Start position in PDF
      });

      // Save PDF
      doc.save(`LiveCasinoResult_${Date.now()}.pdf`);
    };



  return (
    <div className="content-box">
      <div className="report-box">
      <div className="report-title">
        <div className="report-name">{t('Live Casino Bets')}</div>{" "}
        <div className="report-search search-box">
          <div className="form-group mb-0">
          <input type="text" placeholder={t("search")} className="form-control" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
            <img
              src="/images/search.svg"
              className="search-icon" width={'20px'} height={'20px'}
            />
          </div>
        </div>
      </div>
      <div className="report-form">
      <div className="form-group">
          <label>{t('Select Report Type')}</label>
          <select className="form-control" value={selectedTypes}
                onChange={handleTypeChange}>
            <option value="">{t('Select Type')}</option>
            <option value="settled">{t('Settled')}</option>
            <option value="unsettled">{t('Un-Settled')}</option>
          </select>
        </div>
        <div className="form-group from-date">
          <label>{t('From')}</label>{" "}
          <div className="mx-datepicker">
            <div className="mx-input-wrapper">
            <DatePicker
                selected={fromDate}
                onChange={(date) => {
                  setFromDate(date);
                }}
                dateFormat={config.getDateFormated}
                customInput={<CustomInput />}
                maxDate={currentDate}
              />
              <i className="mx-icon-calendar">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 1024 1024"
                  width="1em"
                  height="1em"
                >
                  <path d="M940.218182 107.054545h-209.454546V46.545455h-65.163636v60.50909H363.054545V46.545455H297.890909v60.50909H83.781818c-18.618182 0-32.581818 13.963636-32.581818 32.581819v805.236363c0 18.618182 13.963636 32.581818 32.581818 32.581818h861.090909c18.618182 0 32.581818-13.963636 32.581818-32.581818V139.636364c-4.654545-18.618182-18.618182-32.581818-37.236363-32.581819zM297.890909 172.218182V232.727273h65.163636V172.218182h307.2V232.727273h65.163637V172.218182h176.872727v204.8H116.363636V172.218182h181.527273zM116.363636 912.290909V442.181818h795.927273v470.109091H116.363636z"></path>
                </svg>
              </i>
            </div>
          </div>
        </div>{" "}

        <div className="form-group">
          <label>{t('Type')}</label>
          <select className="form-control" value={selectedProvider}
                onChange={handleProviderChnage}>
          <option value="">{t('Select Type')}</option>
          {config.sub_provider.map((item,index)=>(
            <option key={index} value={item}>{item}</option>
          ))}
          </select>
        </div>
        <button className="btn btn-primary" onClick={()=>callAPIList()}>{t('Submit')}</button>
      </div>
      <div className="report-page-count">
        <div className="form-group mb-0">
          <label>{t('Show')}</label>
          <select className="form-control" value={itemsPerPage} onChange={(e) => setItemsPerPage(Number(e.target.value))}>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
            <option value="300">300</option>
            <option value="400">400</option>
            <option value="500">500</option>
          </select>
          <label>{t('Entries')}</label>
        </div>
        <div className="file-icons">
          <div onClick={generatePDF}>
            <i className="fas fa-file-pdf"></i>
          </div>
          <div id="export_1741083557063" onClick={generateCSV}>
            <i className="fas fa-file-excel"></i>
          </div>
        </div>
      </div>
      <div className="report-table ac-statement table-responsive">
        <table className="table table-hover">
        <thead>
              <tr>
                <th>{t('Game Name')}</th>
                <th>{t('Type')}</th>
                <th>{t('Amount')}</th>
                <th>{t('Total')}</th>
                <th>{t('Date')}</th>
                <th>{t('Round Id')}</th>
                <th>{t('Transaction Id')}</th>
              </tr>
            </thead>
          <tbody>
          {currentItems.length > 0 ? (
            currentItems.map((item, index) => (
              <tr key={index} style={{ cursor: "pointer" }}>
                      <td> {item.event == null || item.event === "" ? "-" : item.event} </td>
                      <td> {item.returns == null || item.returns === "" ? "-" : item.returns > 0 ? "CREDIT":'DEBIT'} </td>
                      <td> {item.Stake == null || item.Stake === "" ? "-" : item.Stake} </td>
                      <td className={`${ item.returns > 0 ? "green-txt" : "red-txt" }`} > {item.returns == null || item.returns === "" ? "-" : item.returns} </td>
                      <td> {item.date == null || item.date === "" ? "-" : formatDatefromAPI(item.date)} </td>
                      <td> {item.roundId == null || item.roundId === "" ? "-" : item.roundId} </td>
                      <td> {item.transactionId == null || item.transactionId === "" ? "-" : item.transactionId} </td>
                    </tr>
            ))
        ) : (
          <tr>
            <td colSpan="6">No results found</td>
          </tr>
        )}
          </tbody>
        </table>
      </div>

      {currentItems.length > 0 ? <ul className="pagination justify-content-center mt-2">
        <li className="page-item disabled" onClick={firstPage} disabled={currentPage === 1}>
          <a tabindex="-1" className="page-link">&lt;&lt;</a>
        </li>
        <li className="page-item disabled" onClick={prevPage} disabled={currentPage === 1}>
          <a tabindex="-1" className="page-link">&lt;</a>
        </li>
        {Array.from({ length: totalPages }, (_, i) => (
        <li className={`page-item ${currentPage === i + 1 ? 'active' : ''}`} key={i} onClick={() => goToPage(i + 1)} style={{ fontWeight: currentPage === i + 1 ? "bold" : "normal" }}>
          <a tabindex="0" className="page-link"> {i + 1}</a>
        </li>
        ))}
        <li className="page-item disabled" onClick={nextPage} disabled={currentPage === totalPages}>
          <a tabindex="-1" className="page-link">&gt;</a>
        </li>
        <li className="page-item disabled" onClick={lastPage} disabled={currentPage === totalPages}>
          <a tabindex="-1" className="page-link">&gt;&gt;</a>
        </li>
      </ul> :''}
      <BetDetailsPopup isOpen={dialogOpen}  handleClose={handleClose} betsData={betsData}/>
    </div>
    </div>
  );
}
